import { UserType } from "../../types/enums";
import { type User, File as SharedFile } from "../../types/interfaces";

export const getLetterOfUser = (fristName: string, userType: UserType) => {
  return userType === UserType.JASPER ? "J" : fristName.slice(0, 1);
};

export interface messages {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  userGroup: {
    name: string;
    groupType: UserType;
    id: string;
  };
  message: string;
  orderId: string;
  files: SharedFile[] | undefined;
  user?: User;
  isNotification?: boolean;
}
